module.exports = __webpack_public_path__ + "556d36eab84f856583904c8244db2cf9.svg";